module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/funabashi_ekimae_point3_4-0a80dd5d65c11a7b0b4d9a46d479184b.jpg";